import { __awaiter, __generator, __assign } from 'tslib';
import { createMediaShareToken, updateMediaShareToken, KpkApiShareTokenExportDefinition } from '@keepeek/api-client';
import Axios from 'axios';
import dayjs from 'dayjs';

function buildPreviewUrl(values, shareTokenTemplateDomains) {
    var _a;
    var uri = (_a = shareTokenTemplateDomains.find(function (sttd) { return sttd.id === parseInt(values.domainId); })) === null || _a === void 0 ? void 0 : _a.uri;
    if (uri) {
        var ret = [];
        if (values.token) {
            ret.push(values.token);
        }
        else {
            ret.push("XXX-XXX-XXX");
        }
        if (values.suffix) {
            ret.push(values.suffix);
        }
        return "".concat(uri, "/").concat(ret.join(""));
    }
    return null;
}
function handleSubmitForCreation(t, enqueueSnackbar, values, setFieldError, elementId, handleClose) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var error_1, errorMessage;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createMediaShareToken(Axios, __assign({ mediaId: elementId }, convertFormikValuesToShareTokenApi(values)))];
                case 1:
                    _d.sent();
                    enqueueSnackbar(t("components.kf-general-public-sharing.creation.success"), {
                        variant: "success"
                    });
                    handleClose(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _d.sent();
                    console.error("error during create media share token", ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) || error_1);
                    errorMessage = t("components.kf-general-public-sharing.creation.error.default");
                    if (((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) === "share-token-already-exist") {
                        errorMessage = t("components.kf-general-public-sharing.creation.error.tokenAlreadyUsed");
                        setFieldError("token", errorMessage);
                    }
                    enqueueSnackbar(errorMessage, {
                        variant: "error"
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleSubmitForUpdate(t, enqueueSnackbar, values, elementId, handleClose) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateMediaShareToken(Axios, __assign({ mediaId: elementId }, convertFormikValuesToShareTokenApi(values)))];
                case 1:
                    _b.sent();
                    enqueueSnackbar(t("components.kf-general-public-sharing.update.success"), {
                        variant: "success"
                    });
                    handleClose(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.error("error during update media share token", ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) || error_2);
                    enqueueSnackbar(t("components.kf-general-public-sharing.update.error"), {
                        variant: "error"
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function convertFormikValuesToShareTokenApi(values) {
    return {
        shareToken: {
            title: values.title,
            tokenValue: values.token,
            suffix: values.suffix,
            manualActivate: values.manualActivate,
            activationDate: values.activationDate ? values.activationDate.toDate() : undefined,
            deactivationDate: values.deactivationDate ? values.deactivationDate.toDate() : undefined,
            exportDefinition: values.exportDefinition,
            templateId: values.templateId ? parseInt(values.templateId) : undefined,
            templateDomainId: values.domainId ? parseInt(values.domainId) : undefined
        }
    };
}
function getInitialValues(element, shareTokenToUpdate, shareTokenTemplates, shareTokenTemplateDomains) {
    if (shareTokenToUpdate) {
        return {
            title: shareTokenToUpdate.title || "",
            templateId: shareTokenToUpdate.templateId || "",
            exportDefinition: shareTokenToUpdate.exportDefinition || "",
            domainId: shareTokenToUpdate.templateDomainId || "",
            token: shareTokenToUpdate.tokenValue || "",
            suffix: shareTokenToUpdate.suffix || "",
            manualActivate: shareTokenToUpdate.manualActivate || false,
            activationDate: (shareTokenToUpdate.activationDate ? dayjs(shareTokenToUpdate.activationDate) : null) ||
                null,
            deactivationDate: (shareTokenToUpdate.deactivationDate ? dayjs(shareTokenToUpdate.deactivationDate) : null) ||
                null
        };
    }
    else {
        return {
            title: "".concat(element === null || element === void 0 ? void 0 : element.id, "-").concat(element === null || element === void 0 ? void 0 : element.title),
            templateId: (shareTokenTemplates === null || shareTokenTemplates === void 0 ? void 0 : shareTokenTemplates.length) !== 0 && shareTokenTemplates[0].id
                ? shareTokenTemplates[0].id
                : "",
            exportDefinition: KpkApiShareTokenExportDefinition.HD,
            domainId: (shareTokenTemplateDomains === null || shareTokenTemplateDomains === void 0 ? void 0 : shareTokenTemplateDomains.length) !== 0 && shareTokenTemplateDomains[0].id
                ? shareTokenTemplateDomains[0].id
                : "",
            token: "",
            suffix: "",
            manualActivate: true,
            activationDate: null,
            deactivationDate: null
        };
    }
}

export { buildPreviewUrl, convertFormikValuesToShareTokenApi, getInitialValues, handleSubmitForCreation, handleSubmitForUpdate };
//# sourceMappingURL=utils.js.map
